export const LANDLORD_SELF_INVITE_PATH = 'api/landlord/onboard/invites';